const QuidSourceCategoryType = Object.freeze({
  NATIONAL_AND_INTERNATIONAL: 'NATIONAL_AND_INTERNATIONAL',
  LOCAL: 'LOCAL',
  TRADE_AND_RESEARCH: 'TRADE_AND_RESEARCH',
  PRESS_RELEASE_AND_WIRE: 'PRESS_RELEASE_AND_WIRE',
  OTHER_CATEGORY: 'OTHER_CATEGORY'
})
export default QuidSourceCategoryType
// RESERVE BELOW
